// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/less/ps.less'
import './assets/less/header.less'
import Icon from 'vue-svg-icon/Icon.vue'
import layer from 'vue-layer'
import errors from './common/errors'
//import iNoBounce from 'inobounce'
import utils from './common/utils';
import * as userApi from './api/userApi'
import * as dd from 'dingtalk-jsapi';
import { SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION } from 'constants';
import MobileApi from './common/MobileApi';
import Vconsole from 'vconsole';

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import Vant from 'vant';
import Cookies from 'js-cookie';



let options = {
		fullscreenEl: false,
}
Vue.use(Vant);
Vue.use(preview, options)


// 引入filters
import filters from './common/filters.js';
// 添加全局filter
Object.keys(filters).map(v => {
	Vue.filter(v,filters[v])
})


var url = window.location.href;
var passUrl = url
if (url.indexOf("#") != -1) {
  passUrl = url.substring(0, url.indexOf("#"))
}

if (passUrl.indexOf("login") == -1 && passUrl.indexOf("logout") == -1
  && passUrl.indexOf("LoginCallBack") == -1
  && passUrl.indexOf("home") != -1
) {
  //  if(passUrl.indexOf("home")!=-1)
  //  {
  userApi.GetDDAuthority({ url: passUrl }).then(res => {
    var result = JSON.parse(res.Data);
    dd.config({
      agentId: result.agentId, // 必填，微应用ID
      corpId: result.corpId, //必填，企业ID
      timeStamp: result.sTimeStamp, // 必填，生成签名的时间戳
      nonceStr: result.nonceStr, // 必填，生成签名的随机串
      signature: result.signature, // 必填，签名
      jsApiList: [
        'runtime.info',
        'device.notification.prompt',
        'biz.chat.pickConversation',
        'device.notification.confirm',
        'device.notification.alert',
        'device.notification.prompt',
        'biz.chat.open',
        'biz.util.open',
        'biz.user.get',
        'biz.contact.choose',
        'biz.telephone.call',
        'biz.telephone.showCallMenu',
        'biz.util.uploadImage',
        'biz.ding.post']
    });
    // 查看鉴权错误信息

  });
  dd.error(function (err) {
    alert('dd error: ' + JSON.stringify(err));
  });
}
const userAgentInfo = window.navigator.userAgent;

const isiOS = !!userAgentInfo.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
// if (isiOS) {
//   //iNoBounce.enable();
// }
// 

Vue.component('icon', Icon)
Vue.config.productionTip = false
Vue.prototype.$layer = layer(Vue, {
  //  目前只有一项，即msg方法的默认消失时间，单位：秒
  msgtime: 3
})
Vue.prototype.$error = errors.errors
Vue.prototype.$isDing = utils.isDing();
Vue.prototype.$isIOS = isiOS;
// 将 Cookies 挂载到 Vue 的原型上
Vue.prototype.$cookies = Cookies;
/* eslint-disable no-new */

MobileApi.init();

// const vConsole = new Vconsole();
// Vue.use(vConsole)

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js